import axiosInstance from "./api";
import TokenService from "./tokenService"
import Vue from "vue";

const setup = (store, router) => {

  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken();
      if (token) {
        config.headers["Authorization"] = 'Bearer ' + token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;

      // Refresh Token expired
      if (err.response.status === 401 && originalConfig.url === "/oauth/access_token") {
        console.log("Refresh Token expired")
        await store.dispatch('LogOut');
        console.log("push login")

        router.push('/login')

      } else if (originalConfig.url !== "/api/login" && originalConfig.url !== "/forgotPassword/resetPassword" && originalConfig.url !== "/oauth/access_token" && err.response) {

        // Access Token expired
        if (err.response.status === 401 && !originalConfig._retry) {

          console.log("Access Token expired")

          originalConfig._retry = true;

          try {

            const params = new URLSearchParams()
            params.append('grant_type', 'refresh_token')
            params.append('refresh_token', TokenService.getLocalRefreshToken())

            const res = await axiosInstance({
              method: 'POST',
              url: '/oauth/access_token',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              data: params
            });

            store.dispatch('refreshToken', res);

            return axiosInstance(originalConfig);
          } catch (_error) {
            return Promise.reject(_error);
          }

        } else if (err.response.status === 500) {
          const vm = new Vue()
          vm.$bvToast.toast(`Veuillez réessayer ultérieurement. Si l'erreur persiste, merci de contacter un administrateur.`, {
            title: "Une erreur s'est produite.",
            autoHideDelay: 2000,
            toaster: 'b-toaster-bottom-right'
          })
        }
      }

      return Promise.reject(err);
    }
  );
};

export default setup;



// WEBPACK FOOTER //
// ./src/services/setupInterceptors.js